import styled from "styled-components"
import { tabletSize, mobileSize, userSelect, colors } from "../../constants"

export const Container = styled.div`
  padding: 60px 30px;
  transition: padding 0.3s ease-in;
  @media (max-width: ${mobileSize}) {
    padding: 40px 20px;
  }
`
